<template>
  <div class="myTable">
    <table>
      <thead v-if="columns.length > 0">
        <tr>
          <th v-for="(column, index) in columns" :key="index">
            {{ column.name }}
          </th>
        </tr>
      </thead>
      <tbody v-if="tableData.length > 0">
        <tr v-for="(data, index) in tableData" :key="index">
          <td v-for="(value, key) in data" :key="key">
            {{ value }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
    },
    tableData: {
      type: Array,
    },
  },
};
</script>

<style lang="less">
.myTable {
  min-width: 96%;
  overflow-x: scroll;
  background: #fff;
  padding: 2%;
  table {
    width: 100%;
    text-align: center;
    th {
      line-height: 40px;
    }
    tbody {
      tr {
        &:nth-of-type(2n-1) {
          background: #ced4de;
        }
        td {
          line-height: 28px;
        }
      }
    }
  }
}
@media (max-width: 1200px) {
  .myTable table {
    width: 1200px;
  }
}
</style>
